import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAlert } from '@rahtab/ui';
import { useNavigation } from '@react-navigation/core';
import { useAppDispatch } from 'rahtab-redux';
import { setViewerHasNTSWCode } from 'rahtab-redux/slices/viewerSlice';

export const useNTSW = ({ otp, roleId }: { otp: string; roleId: string }) => {
  const alert = useAlert();
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const [requestCode] = useFetchCallType<ResultOutput>('SendOtpCodeRequest', {
    skip: true,
    onCompleted: ({ result, error, message }) => {
      alert({
        message: error || message,
        title: 'پیام سیستم',
        severity: result ? 'success' : 'error',
      });
    },
  });
  const [submitCode] = useFetchCallType<ResultOutput>('SaveOtpCode', {
    params: `OtpCode=${otp}&NtswRoleCode=${roleId}`,
    skip: true,
    onCompleted: ({ result, error, message }) => {
      alert({
        message: error || message,
        title: 'پیام سیستم',
        severity: result ? 'success' : 'error',
      });
      if (!result) return;
      dispatch(setViewerHasNTSWCode(true));
      navigation.goBack();
    },
  });

  return { requestCode, submitCode };
};

interface ResultOutput {
  result: boolean;
  error: string;
  message: string;
}
